// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"gk-z","hideOnMobile":"hk-z"};